import { makeStyles } from '@material-ui/core'
// import { styled } from '@mui/material/styles'
export const useStyles = makeStyles({
  paragraph: {
    fontSize: 14,
  },
  spacing: {
    marginTop: 10,
  },
  alertWarning: {
    alignItems: 'center',
    '& > .MuiAlert-message': {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
  },
  button: {
    padding: '8px !important',
    background: '#143A5F !important',
    color: 'white !important',
    fontWeight: '600',
    maxHeight: '35.5px',
    '&:hover': {
      background: 'white !important',
      color: '#143A5F !important',
      border: '1px solid #143A5F',
    },
    '&:disabled': {
      color: '#66666699 !important',
      background: '#e6e5e5a8 !important',
      borderColor: '#e4e6ef !important',
    },
  },
})
